<template>
  <b-modal
    centered
    v-if="isOpen"
    v-model="isOpen"
    cancel-disabled
    hide-footer
    title="Erro na integração"
    size="lg"
  >
    <b-alert
      show
      variant="warning"
      class="d-flex align-items-center text-justify"
    >
      <div>
        <i class="fas fa-exclamation-triangle mr-3"></i> Algumas mensagens de
        erro abaixo são retornadas pelo próprio Mercado Livre, a Constr Up não
        tem controle sobre elas. Para maiores informações acesse o link da
        documentação de
        <a href="https://developers.mercadolivre.com.br/pt_br/validacoes"
          >validações do Mercado Livre</a
        >.
      </div>
    </b-alert>
    <div>
      Houve um erro ao integrar o produto <b>{{ productName }}</b
      >:
    </div>

    <div class="mt-2">
      <b>Dados enviados:</b>
      <pre><code id="output">{{ JSON.stringify(JSON.parse(payload), null, 2) }}</code></pre>
    </div>
    <div>
      <b>Erro:</b>
      <pre
        v-if="error"
      ><code id="output">{{ JSON.stringify(JSON.parse(error), null, 2) }}</code></pre>
      <div v-else>
        Sem erros reportados. Consulte o nosso suporte para mais informações
        sobre o que pode ter ido errado.
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'IntegrationErrorModal',
  data() {
    return {
      isOpen: false,
      productName: '',
      error: '',
      payload: '',
    };
  },
  methods: {
    open(productName, error, payload) {
      this.isOpen = true;
      this.productName = productName;
      this.error = error;
      this.payload = payload;
    },
    close() {
      this.isOpen = false;
      this.productName = '';
      this.error = '';
      this.payload = '';
    },
  },
};
</script>

<style scoped>
pre {
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  max-width: 100%;
}

pre code {
  font-family: 'Roboto Mono', monospace;
  white-space: pre-wrap;
  word-break: break-all;
}
</style>
